import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
export class GroupPrice extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.price = 0;
        this.reducedPrice = null;
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], GroupPrice.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], GroupPrice.prototype, "reducedPrice", void 0);
/**
 * A group can have multiple prices, stored in an array. The pricing with the highest date or index is applied.
 */
export class GroupPrices extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.startDate = null;
        /**
         * Whether the array count is per member of the same family (true) or only the same member (false)
         */
        this.sameMemberOnlyDiscount = false;
        /**
         * Count members in same category or only for the same group?
         */
        this.onlySameGroup = false;
        /**
         * The array contains prices: for first member, second member... If more members are present in a family (or member itself), the last price is used
         */
        this.prices = [GroupPrice.create({})];
        /**
         * @deprecated
         */
        this.price = 0;
        /**
         * @deprecated
         */
        this.reducedPrice = null;
        /**
         * @deprecated
         * Second member in the family
         */
        this.familyPrice = null;
        /**
         * @deprecated
         * Third or later member
         */
        this.extraFamilyPrice = null;
    }
    getPriceFor(reduced, alreadyRegisteredCount = 0) {
        var _a;
        if (this.prices.length == 0 || alreadyRegisteredCount < 0) {
            return 0;
        }
        const price = this.prices[Math.min(this.prices.length - 1, alreadyRegisteredCount)];
        if (reduced) {
            return (_a = price.reducedPrice) !== null && _a !== void 0 ? _a : price.price;
        }
        return price.price;
    }
}
__decorate([
    field({ decoder: StringDecoder, version: 2, defaultValue: () => uuidv4() })
], GroupPrices.prototype, "id", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], GroupPrices.prototype, "startDate", void 0);
__decorate([
    field({ decoder: BooleanDecoder, upgrade: () => false, version: 99 })
], GroupPrices.prototype, "sameMemberOnlyDiscount", void 0);
__decorate([
    field({ decoder: BooleanDecoder, upgrade: () => false, version: 99 })
], GroupPrices.prototype, "onlySameGroup", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(GroupPrice), version: 98, upgrade: function () {
            const arr = [
                GroupPrice.create({
                    price: this.price,
                    reducedPrice: this.reducedPrice
                })
            ];
            if (this.familyPrice !== null) {
                arr.push(GroupPrice.create({
                    price: this.familyPrice,
                    reducedPrice: (this.reducedPrice !== null && this.familyPrice < this.reducedPrice) ? null : this.reducedPrice
                }));
                if (this.extraFamilyPrice !== null) {
                    arr.push(GroupPrice.create({
                        price: this.extraFamilyPrice,
                        reducedPrice: (this.reducedPrice !== null && this.extraFamilyPrice < this.reducedPrice) ? null : this.reducedPrice
                    }));
                }
            }
            return arr;
        } })
], GroupPrices.prototype, "prices", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], GroupPrices.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], GroupPrices.prototype, "reducedPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 22 })
], GroupPrices.prototype, "familyPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 22 })
], GroupPrices.prototype, "extraFamilyPrice", void 0);
//# sourceMappingURL=GroupPrices.js.map